// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100%\" height=\"100%\" viewBox=\"0 0 14 8\"> <g transform=\"translate(-4.939 -7.939)\"> <path d=\"M6,9l6,6,6-6\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5px\"/> </g> </svg> ";
// Exports
module.exports = code;